
import { useNavigate } from 'react-router-dom';
import { trackAddToCart, trackInitiateCheckout } from '../../../utils/metaPixel';

interface Product {
  id: number;
  name: string;
  subtitle: string;
  description: string;
  price: string;
  image: string;
  icon: string;
  shopifyUrl?: string;
}

const parsePrice = (price: string): number => {
  const num = parseFloat(String(price).replace('€', '').replace(',', '.').trim());
  return isNaN(num) ? 0 : num;
};

export default function Products() {
  const navigate = useNavigate();

  const products: Product[] = [
    {
      id: 1,
      name: 'Exfoliant au riz blanc coréen',
      subtitle: 'Effet brillance éclat naturel',
      description: 'Un soin plus doux pour une fraîcheur ultra-douce - 120ML',
      price: '29,99€',
      image: 'https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/ba36a2daa77d320d8e1522823e5783cf.jpeg',
      icon: '1',
      shopifyUrl: 'https://peau-perlee-2.myshopify.com/products/exfoliant-dr-melaxin-white-1',
    },
    {
      id: 2,
      name: 'Exfoliant au riz noir coréen',
      subtitle: 'Élimine les points noirs et impuretés',
      description: 'Nettoie en profondeur et affine les pores - 120ML',
      price: '29,99€',
      image: 'https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/78472e3a543b465e33a0bbe9a4f4d44c.jpeg',
      icon: '2',
      shopifyUrl: 'https://peau-perlee-2.myshopify.com/products/exfoliant-dr-melaxin-black',
    },
    {
      id: 3,
      name: 'Masque Biodance hydrogel coréen',
      subtitle: 'Effet brillance (ce coffret contient 4 masques)',
      description: 'Texture veloutée et hydratation longue durée',
      price: '24€',
      image: 'https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/3249d0d200fdb86be4a562faa02f1cd5.jpeg',
      icon: '3',
      shopifyUrl: 'https://peau-perlee-2.myshopify.com/products/masque-bio-collagene',
    },
    {
      id: 4,
      name: 'Sérum Hydratation Intense à l\'acide hyaluronique et à l\'ADN de saumon',
      subtitle: 'Hydrate en profondeur',
      description: 'Formule concentrée pour une peau repulpée',
      price: '21€',
      image: 'https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/1602f47fc5c338524c2d73312a9ce4bd.jpeg',
      icon: '4',
      shopifyUrl: 'https://peau-perlee-2.myshopify.com/products/serum-hyaluronic-pdrn',
    },
    {
      id: 5,
      name: 'Kit de 12 ampoules à l\'ADN de saumon',
      subtitle: 'Renforce la barrière cutanée (ce kit contient 12 ampoules)',
      description: 'Des ampoules hautement concentrées en ADN de saumon (PDRN) pour une réparation cutanée ciblée et efficace',
      price: '59,99€',
      image: 'https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/52073c4866169d9ce3c0dd309da0a167.jpeg',
      icon: '5',
      shopifyUrl: 'https://peau-perlee-2.myshopify.com/products/kit-12-ampoules-saumon',
    },
    {
      id: 6,
      name: 'Crème Advanced PDRN à l\'ADN de saumon',
      subtitle: 'Convient à tous les types de peau',
      description: 'Formule universelle testée dermatologiquement',
      price: '36,99€',
      image: 'https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/20c6073d9eaedb2424a5aa68c736fad5.jpeg',
      icon: '6',
    },
  ];

  const handleProductClick = (productId: number) => {
    navigate(`/produit?id=${productId}`);
  };

  const handleBuyProduct = (e: React.MouseEvent, product: Product) => {
    e.stopPropagation();
    trackAddToCart({
      content_name: product.name,
      content_ids: [String(product.id)],
      content_type: 'product',
      value: parsePrice(product.price),
      currency: 'EUR',
      num_items: 1,
    });
    if (product.shopifyUrl) {
      window.open(product.shopifyUrl, '_blank');
    }
  };

  const handleDuoOffer = () => {
    trackInitiateCheckout({
      content_name: 'Duo Exfoliants Riz Blanc + Riz Noir',
      content_ids: ['1', '2'],
      content_type: 'product',
      value: 49.99,
      currency: 'EUR',
      num_items: 2,
    });
  };

  return (
    <section className="py-20 bg-white" data-product-shop>
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        {/* Offre promotionnelle - Duo Exfoliants */}
        <div className="mb-16 bg-gradient-to-br from-[#FFF5F3] to-[#FFE8E3] rounded-3xl p-8 lg:p-12 relative overflow-hidden">
          <div className="absolute top-6 right-6 bg-red-500 text-white px-6 py-2 rounded-full font-bold text-sm shadow-lg">
            OFFRE SPÉCIALE
          </div>
          
          <div className="text-center mb-8">
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Duo Exfoliants Riz Blanc + Riz Noir
            </h3>
            <p className="text-lg text-gray-700">
              La routine complète pour une peau éclatante et purifiée - 2 x 120ML
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 mb-8">
            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="w-full h-64 mb-4 rounded-xl overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/ba36a2daa77d320d8e1522823e5783cf.jpeg"
                  alt="Exfoliant au riz blanc coréen"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Exfoliant au riz blanc coréen</h4>
              <p className="text-sm text-gray-600 mb-3">Effet brillance et éclat</p>
              <p className="text-lg font-semibold text-gray-500 line-through">29,99€</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="w-full h-64 mb-4 rounded-xl overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/78472e3a543b465e33a0bbe9a4f4d44c.jpeg"
                  alt="Exfoliant au riz noir coréen"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Exfoliant au riz noir coréen</h4>
              <p className="text-sm text-gray-600 mb-3">Élimine les points noirs</p>
              <p className="text-lg font-semibold text-gray-500 line-through">29,99€</p>
            </div>
          </div>

          <div className="text-center">
            <div className="mb-6">
              <p className="text-sm text-gray-600 mb-2">Prix unitaire : 59,98€</p>
              <div className="flex items-center justify-center gap-4">
                <span className="text-5xl font-bold text-gray-900">49,99€</span>
                <div className="bg-green-500 text-white px-4 py-2 rounded-full font-bold text-sm">
                  Économisez 10€
                </div>
              </div>
            </div>

            <a 
              href="https://peau-perlee-2.myshopify.com/products/exfoliant-dr-melaxin-white"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleDuoOffer}
              className="inline-block px-12 py-4 bg-gray-900 text-white text-lg font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              Profiter de l'offre duo
            </a>

            <p className="text-sm text-gray-600 mt-4">
              ✨ Livraison gratuite •&nbsp;
            </p>
          </div>
        </div>

        {/* Grille produits - 3 colonnes */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <div 
              key={product.id} 
              className="group cursor-pointer"
              onClick={() => handleProductClick(product.id)}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-[#E8B4A8] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                  {product.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900">{product.name}</h3>
              </div>

              <div className="relative mb-6 rounded-2xl overflow-hidden bg-[#F5F5F5]">
                <div className="w-full h-80">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>

              <div>
                <h4 className="text-base font-semibold text-gray-900 mb-2">{product.subtitle}</h4>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{product.description}</p>

                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-2xl font-bold text-gray-900">{product.price}</span>
                    {product.id === 3 && (
                      <p className="text-xs text-gray-500 mt-1">Soit 6€ le masque</p>
                    )}
                    {product.id === 5 && (
                      <p className="text-xs text-gray-500 mt-1">Soit 5€ l'ampoule</p>
                    )}
                  </div>
                  <a 
                    href={product.shopifyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => handleBuyProduct(e, product)}
                    className="block w-full py-3 bg-gray-900 text-white text-base font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
                  >
                    Acheter maintenant
                  </a>
                </div>

                <div className="flex items-center justify-center gap-2 mt-3 text-gray-600">
                  <i className="ri-lock-line text-base"></i>
                  <span className="text-xs font-medium">Paiement sécurisé</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Produit mis en valeur - Masque LED */}
        <div className="mt-20 bg-gradient-to-br from-[#FFF5F3] to-[#FFE8E3] rounded-3xl p-8 lg:p-12">
          <div className="text-center mb-8">
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Prolongez les résultats de votre routine skincare avec un soin LED professionnel à domicile
            </h3>
          </div>

          <div 
            className="grid lg:grid-cols-2 gap-8 items-center cursor-pointer group"
            onClick={() => handleProductClick(7)}
          >
            <div className="relative rounded-2xl overflow-hidden bg-white">
              <div className="w-full h-96">
                <img 
                  src="https://static.readdy.ai/image/17f891913f567fd5bf7bcc70827cac74/33d66dc22c10ec7e2f37073672c77404.jpeg"
                  alt="Masque LED professionnel"
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>

            <div className="text-center lg:text-left">
              <div className="flex items-center justify-center lg:justify-start gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#E8B4A8] flex items-center justify-center text-white font-bold text-lg flex-shrink-0">
                  7
                </div>
                <h4 className="text-2xl lg:text-3xl font-bold text-gray-900">Masque LED professionnel</h4>
              </div>

              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Technologie LED 7 couleurs pour une peau éclatante et rajeunie. Traite l'acné, réduit les rides, améliore l'élasticité et unifie le teint. Résultats visibles dès 4 semaines.
              </p>

              <div className="flex items-center justify-center lg:justify-start gap-6 mb-8">
                <span className="text-4xl font-bold text-gray-900">79,99€</span>
                <span className="text-lg text-gray-500 line-through">119,99€</span>
              </div>

              <button className="px-10 py-4 bg-gray-900 text-white text-base font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl">
                Découvrir le masque LED
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
